const EMAIL_PATTERN = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
// 7+ digit runs with common separators (spaces, dashes, dots, parens) shaped like a phone number.
const PHONE_PATTERN = /(?:\+?\d[\d\-.() ]{6,}\d)/g;
const LONG_DIGIT_RUN_PATTERN = /\d{12,}/g;
const URL_PATTERN = /https?:\/\/[^\s]+/g;
function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function redactUrls(text) {
    return text.replace(URL_PATTERN, (match) => {
        try {
            const url = new URL(match);
            return `${url.origin}${url.pathname}`;
        }
        catch {
            return match;
        }
    });
}
function redactPersonalValues(text, incident) {
    let result = text;
    const values = [incident.contactName, incident.contactEmail]
        .filter((v) => Boolean(v && v.trim().length > 0))
        // Longest match first so a name that is a substring of another value doesn't shadow it.
        .sort((a, b) => b.length - a.length);
    for (const value of values) {
        const replacement = value === incident.contactEmail ? "[EMAIL]" : "[NAME]";
        result = result.replace(new RegExp(escapeRegExp(value), "gi"), replacement);
    }
    return result;
}
/**
 * Pure transform applied only at the point content leaves the app (copy/export). The stored
 * record must stay raw so a human can reply to the person; never call this on ingest.
 */
export function deidentify(incident) {
    let body = incident.body;
    body = redactPersonalValues(body, incident);
    body = body.replace(EMAIL_PATTERN, "[EMAIL]");
    // Long, unbroken digit runs (pasted account/card numbers) are matched before the phone
    // pattern, since a bare 12+ digit run would otherwise satisfy the phone shape too.
    body = body.replace(LONG_DIGIT_RUN_PATTERN, "[NUMBER]");
    body = body.replace(PHONE_PATTERN, "[PHONE]");
    body = redactUrls(body);
    return {
        ...incident,
        body,
        contactEmail: incident.contactEmail ? "[EMAIL]" : incident.contactEmail,
        contactName: incident.contactName ? "[NAME]" : incident.contactName,
    };
}
